var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRanks = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 26,
  height: 30,
  viewBox: "0 0 26 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 13.277,
  cy: 20.727,
  rx: 9.404,
  ry: 9.273,
  fill: "currentColor"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.114 0c-.167 0-.33.1-.406.25a.473.473 0 0 0 .036.477l7.576 10.59 4.274-5.931L9.85.188A.46.46 0 0 0 9.48 0H2.114ZM18.18.602a.46.46 0 0 0-.37.188l-7.615 10.569a8.895 8.895 0 0 1 3.24-.601 9.399 9.399 0 0 1 4.563 1.093c.096.047.19.098.284.149l7.633-10.671a.473.473 0 0 0 .037-.478.465.465 0 0 0-.406-.25H18.18Z",
  fill: "#EBE4DA"
})));
export default SvgRanks;